import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";
import displayFlashMessage from "../../functions/displayFlashMessage.js";
import {
  addAjaxPending,
  removeAjaxPending,
} from "../../functions/ajaxPending.js";

export default class extends Controller {
  onSuccess(event) {
    const response = JSON.parse(event.detail.response);

    this.element.reset();

    if (response.redirectTo) {
      const originalUrl = new URL(window.location.href);
      const redirectUrl = new URL(response.redirectTo, window.location.origin);

      window.location.replace(redirectUrl);

      if (originalUrl.pathname !== redirectUrl.pathname) {
        return;
      }
    }

    response.messages.forEach(function (message) {
      displayFlashMessage(message);
    });

    this.successEvents.forEach(function (eventName) {
      dispatchCustomEvent(document, eventName);
    });
  }

  onError(event) {
    const response = JSON.parse(event.detail.response);

    if (response.redirectTo) {
      window.location.replace(response.redirectTo);
    }

    response.messages.forEach(function (message) {
      displayFlashMessage(message);
    });
  }

  addPending() {
    addAjaxPending(this.element);
  }

  removePending() {
    removeAjaxPending(this.element);
  }

  showOverlay() {
    const event = new CustomEvent("overlay:show", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  hideOverlay() {
    const event = new CustomEvent("overlay:hide", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  get successEvents() {
    if (!this.element.dataset.ajaxRequestSuccessEvents) {
      return [];
    }

    return this.element.dataset.ajaxRequestSuccessEvents.split(" ");
  }
}
